import Module from "layout/Module";
import useAZZKUCharts from "hooks/AZZKU/useAZZKUCharts";
import useAZZKULatestEdition from "hooks/AZZKU/useAZZKULatestEdition";

import StepsBox from "components/StepsBox";
import AZZKUResultsSidebar from "./components/AZZKUResultsSidebar";
import AZZKUResultsMain from "./components/AZZKUResultsMain";

import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import Step4 from "./steps/Step4";

export default function AZZKUModule() {
   const { d: editionData } = useAZZKULatestEdition();

   return (
      <Module
         results_props={{
            dataHook: useAZZKUCharts,
            SidebarComponent: AZZKUResultsSidebar,
            MainComponent: AZZKUResultsMain
         }}

         Component={(props) => (
            <>
               <h2> Wybierz zakres danych </h2>

               <p> Wybierz dane oraz filtry, które chcesz uwzględnić w generowanym raporcie. </p>

               <StepsBox
                  {...props}
                  editionData={editionData}
                  steps={[
                     {
                        title: "Krok 1: Wybór danych",
                        next_btn: "Przejdź do wyboru zawodów",
                        validation_fields: [{
                           name: "topics",
                           fn: data => !!data.topics && !!data.topics?.length,
                           message: "Proszę wybrać temat"
                        }, {
                           name: "variable_id",
                           message: "Proszę wybrać wskaźnik"
                        }],
                        Content: Step1
                     },
                     {
                        title: "Krok 2: Wybór zawodów",
                        prev_btn: "Wróć do wyboru danych",
                        next_btn: "Przejdź do wyboru lat",
                        validation_fields: [{
                           name: "profession_ids",
                           fn: data => Array.isArray(data.profession_ids) && !!data.profession_ids?.length && data.profession_ids?.length <= 8,
                           message: "Wybierz do 8 zawodów"
                        }],
                        Content: Step2
                     },
                     {
                        title: "Krok 3: Wybór lat",
                        prev_btn: "Wróć do wyboru zawodów",
                        next_btn: "Przejdź do wyboru obszaru",
                        validation_fields: [
                           { name: "values_type" },
                           {
                              name: "years",
                              fn: data => data.values_type === "dynamics_change" || (data.values_type === "raw" && !!data.years?.length)
                           },
                           {
                              name: "base_year",
                              fn: data => data.values_type === "raw" || (data.values_type === "dynamics_change" && !!data.base_year)
                           },
                           {
                              name: "compare_year",
                              fn: data => data.values_type === "raw" || (data.values_type === "dynamics_change" && !!data.compare_year)
                           }
                        ],
                        Content: Step3
                     },
                     {
                        title: "Krok 4: Wybór obszaru",
                        prev_btn: "Wróć do wyboru lat",
                        next_btn: "Generuj wyniki",
                        Content: Step4
                     }
                  ]}
               />
            </>
         )}
      />
   )
}